import { useEffect, useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import { electronicInvoicingApi } from "../../api/electronicInvoicingApi";

export default function InvoiceNotificationsPage() {
  const { token } = useAuth() as any;
  const [sent, setSent] = useState<any[]>([]);
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => {
    electronicInvoicingApi.listSentInvoices(token).then((invoices) => {
      setSent(invoices);
      return Promise.all(invoices.slice(0, 20).map((x: any) => electronicInvoicingApi.listInvoiceNotifications(token, x.id)));
    }).then((all) => {
      setRows(all.flat());
    }).catch(() => {
      setRows([]);
      setSent([]);
    });
  }, [token]);

  return (
    <div className="container-fluid">
      <h3 className="mb-3">Esiti / notifiche SDI</h3>
      <div className="mb-2 text-muted small">Fatture inviate: {sent.length}</div>
      <div className="card shadow-sm">
        <div className="table-responsive">
          <table className="table mb-0">
            <thead className="table-light">
              <tr>
                <th>Ricevuta</th>
                <th>Tipo</th>
                <th>Stato</th>
                <th>Messaggio</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((n) => (
                <tr key={n.id}>
                  <td>{new Date(n.receivedAt).toLocaleString("it-IT")}</td>
                  <td>{n.notificationType}</td>
                  <td>{n.status}</td>
                  <td>{n.message ?? "-"}</td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td colSpan={4} className="text-center text-muted py-4">Nessuna notifica disponibile</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
